import { Public, ProtectedRoute, PrivilegedRoute } from '@middlewares';

import Eventos from '@pages/Events/Eventos';
import PreguntasPost from '@pages/Events/PreguntasPost';
import Invitados from '@pages/Events/Invitados';
import InvitadosEvent from '@pages/Events/InvitadosEvent';
import Staff from '@pages/Events/Staff';
import StaffEvent from '@pages/Events/StaffEvent';
import EventosPaseLista from '@pages/Events/EventosPaseLista';
import EventosPaseListaInfo from '@pages/Events/EventosPaseListaInfo';
import PreRegistro from '@pages/Events/PreRegistro';
import Dashboard from '@pages/Events/Dashboard';
import Noticias from '@pages/Noticias/Noticias';
import Registro from '@pages/Ppm/Registro';
import UploadInformation from '@pages/Ppm/UploadInformation';
import Banner from '@pages/Ppm/Banner';
import EventosGaleria from '@pages/Ppm/EventosGaleria';
import Publicaciones from '@pages/Foca/Publicaciones';

import { PAGINA_PPM } from '@data/constants/Noticias';
import { ID_PPM } from '@data/constants/Eventos';
import TemplatesQR from '@pages/Events/TemplatesQR';

const PpmRoutes = [
  {
    path: '/ppm/eventos',
    element: <PrivilegedRoute title="Eventos" page={<Eventos idTipoEvento={ID_PPM} id="ppm" />} />,
  },
  {
    path: '/ppm/eventos/preguntas',
    element: <ProtectedRoute title="Preguntas" page={<PreguntasPost idTipoEvento={ID_PPM} id="ppm" />} />,
  },
  {
    path: '/ppm/eventos/invitados',
    element: <PrivilegedRoute title="Invitados" page={<Invitados idTipoEvento={ID_PPM} id="ppm" />} />,
  },
  {
    path: '/ppm/eventos/invitados/:id',
    element: <ProtectedRoute title="Invitados" page={<InvitadosEvent />} />,
  },
  {
    path: '/ppm/eventos/staff',
    element: <PrivilegedRoute title="Staff" page={<Staff idTipoEvento={ID_PPM} id="ppm" />} />,
  },
  {
    path: '/ppm/eventos/staff/:id',
    element: <ProtectedRoute title="Staff" page={<StaffEvent />} />,
  },
  {
    path: '/ppm/eventos/pase-lista',
    element: <PrivilegedRoute title="Pase de lista" page={<EventosPaseLista idTipoEvento={ID_PPM} />} />,
  },
  {
    path: '/ppm/eventos/pase-lista/:id',
    element: <ProtectedRoute title="Pase de lista" page={<EventosPaseListaInfo />} />,
  },
  {
    path: '/ppm/noticias',
    element: <PrivilegedRoute title="Noticias" page={<Noticias page={PAGINA_PPM} />} />,
  },
  {
    path: '/ppm/registro',
    element: <PrivilegedRoute title="Registro" page={<Registro />} />,
  },
  {
    path: '/reconocimientos/upload',
    element: <ProtectedRoute title="Reconocimientos" page={<UploadInformation />} />,
  },
  {
    path: '/ppm/eventos/dashboard/:id',
    element: <ProtectedRoute title="Dashboard" page={<Dashboard />} />,
  },
  {
    path: '/ppm/eventos/preregistro/:id',
    element: <Public title="Preregistro" page={<PreRegistro idTipoEvento={ID_PPM} />} />,
  },
  {
    path: '/ppm/banner',
    element: <PrivilegedRoute title="Banner" page={<Banner id="ppm" />} />,
  },
  {
    path: '/ppm/galeria',
    element: <ProtectedRoute title="Galería" page={<EventosGaleria />} />,
  },
  {
    path: '/ppm/publicaciones',
    element: <PrivilegedRoute title="Publicaciones" page={<Publicaciones id="ppm" />} />,
  },
  {
    path: '/ppm/plantillas',
    element: <ProtectedRoute title="Registro Plantillas" page={<TemplatesQR idTipo={3} />} />,
  },
];

export default PpmRoutes;
